module.exports = __webpack_public_path__ + "img/myApprovalCopyico@2x.00904468.png";